import {
	normalizeStatusKey,
	normalizeStatusLabel,
} from "../../../../../../../../../shared/utils/normalize-status-label";

interface SortInfo {
	sortMethod: string;
	sortBy: string;
}

const STATUS_PRIORITY: Record<string, number> = {
	ENABLED: 0,
	ACTIVE: 0,
	CHECK: 1,
	SUSPENDED: 2,
};

const accountStatusFilterKey = (
	raw: string | number | null | undefined,
): string => {
	const key = normalizeStatusKey(raw);
	return key === "enabled" ? "active" : key;
};

const getAccountStatusPriorityRank = (
	raw: string | number | null | undefined,
): number | undefined => {
	const label = normalizeStatusLabel(raw);
	const mapKey = label.replace(/\s+/g, "_");
	return STATUS_PRIORITY[mapKey];
};

export const processAccounts = (
	data: any[] | undefined,
	selectedStatus: string,
	sortInfo: SortInfo,
) => {
	const processed = (data || []).filter((item) => {
		if (selectedStatus === "all") return true;
		const selectedNorm =
			selectedStatus === "enabled" ? "active" : selectedStatus;
		return accountStatusFilterKey(item.status) === selectedNorm;
	});

	const sorted = processed.slice().sort((a, b) => {
		const { sortBy, sortMethod } = sortInfo;
		let va: any = "";
		let vb: any = "";

		switch (sortBy) {
			case "name":
				va = a.account_name ?? "";
				vb = b.account_name ?? "";
				break;
			case "status": {
				const ra = getAccountStatusPriorityRank(a.status);
				const rb = getAccountStatusPriorityRank(b.status);
				const aUnknown = ra === undefined;
				const bUnknown = rb === undefined;
				if (aUnknown && bUnknown) {
					const sa = normalizeStatusLabel(a.status);
					const sb = normalizeStatusLabel(b.status);
					const cmp = String(sa).localeCompare(String(sb), undefined, {
						sensitivity: "base",
						numeric: true,
					});
					return sortMethod === "asc" ? cmp : -cmp;
				}
				if (aUnknown) return 1;
				if (bUnknown) return -1;
				const diff = ra - rb;
				return sortMethod === "asc" ? diff : -diff;
			}
			case "cost":
				va = parseFloat(String(a.cost_usd)) || 0;
				vb = parseFloat(String(b.cost_usd)) || 0;
				break;
			default:
				va = a.account_name ?? "";
				vb = b.account_name ?? "";
		}

		if (typeof va === "number" && typeof vb === "number") {
			return sortMethod === "asc" ? va - vb : vb - va;
		}

		const cmp = String(va).localeCompare(String(vb), undefined, {
			sensitivity: "base",
			numeric: true,
		});
		return sortMethod === "asc" ? cmp : -cmp;
	});

	return sorted;
};
